// extracted by mini-css-extract-plugin
export default {"title":"styles_title__vbsi-","table":"styles_table__w+a2q","prettyJson":"styles_prettyJson__KvhMC"};